import { ApiError } from '../api/errors';

export type AuthStatus = 'disabled' | 'loading' | 'signed_out' | 'signed_in' | 'error';
export type ViewerProfileStatus = 'idle' | 'loading' | 'ready' | 'legal_required' | 'error';

interface ProfileFailure {
  status: Extract<ViewerProfileStatus, 'legal_required' | 'error'>;
  message: string | null;
  clearProfile: boolean;
  openLegalGate: boolean;
}

export function shouldRefreshViewerProfile(
  authStatus: AuthStatus,
  profileStatus: ViewerProfileStatus,
): boolean {
  return authStatus === 'signed_in' && profileStatus === 'idle';
}

export function nextProfileFailure(error: unknown): ProfileFailure {
  if (error instanceof ApiError) {
    if (error.code === 'authentication_required') {
      return {
        status: 'error',
        message: 'Backend did not accept the current session. Sign out and sign in again.',
        clearProfile: true,
        openLegalGate: false,
      };
    }

    if (error.code === 'legal_acceptance_required') {
      return {
        status: 'legal_required',
        message: null,
        clearProfile: false,
        openLegalGate: true,
      };
    }

    if (error.code === 'auth_verifier_unavailable') {
      return {
        status: 'error',
        message: 'Backend auth verifier is not available. Customer auth is not launch-ready.',
        clearProfile: false,
        openLegalGate: false,
      };
    }

    return {
      status: 'error',
      message: error.message,
      clearProfile: false,
      openLegalGate: false,
    };
  }

  return {
    status: 'error',
    message: error instanceof Error ? error.message : 'Profile request failed',
    clearProfile: false,
    openLegalGate: false,
  };
}
